import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "./app-token.service";
import { HttpHandlerService } from "./http-handler.service";
@Injectable()

export class RateBandsService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getAllEndPoint = 'ratebands';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getAllEndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

}